module.exports = __webpack_public_path__ + "static/media/background1.28761012.jpg";